<template>
	<div class="modal-container location-edit-modal" v-bind:id="uniqueID">
		<div class="modal-content modal-content-regular">
			<div class="modal-close modal-close-cross"></div>
			<div class="bg--white border--round ">
				<div class="container">
					<div class="loading-overlay" v-if="loading">
						<div class="spinner-wrapper">
							<span class="spinner-text">LOADING</span>
							<span class="spinner"></span>
						</div>
					</div>
					<div v-else="!loading">
						<h3>Editing Location</h3>
						<LocationEdit v-model="location" @saved="editSave()" @canceled="editCancel()" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LocationEditModal',
	props: ['uniqueID'],
	mounted () {
		var self = this;
		document.addEventListener("modalClosed.modals.mr", function(event) {
			self.setLocation(null);
		});
	},
	data: function(){
		return {
			loading: true,
			locationID: null,
			location:{
			},
		};
	},
	methods:{
		closeModal:function(){
			mr.modals.closeActiveModal();
			this.loading = true;
			this.locationID = null;
			this.location = {};
		},
		editCancel:function(){
			this.$emit('canceled', this.locationID);
			this.closeModal();
		},
		editSave:function(){
			this.$emit('saved', this.locationID);
			this.closeModal();
		},
		setLocation:function (locationID){
			this.$emit('locationChanged', locationID);
		},
		showLocation: function(locationID){
			var self = this;
			self.loading = true;
			if (isNaN(locationID)) {
				return;
			}

			this.setLocation(locationID);
			self.locationID = locationID;

			var qs = "&include[]=meta";

			self.API({
				endpoint: 'locations/'+locationID,
				querystring: qs,
				funcThen: function(response){
					mr.modals.showModal($('#' + self.uniqueID));
					self.location = response.data.location;
					self.loading = false;
				}
			});
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/LocationEditModal.vue